module.exports = __webpack_public_path__ + "img/green-check.295a3b3d.svg";